import { useMemo } from "react";
import { GeneralOrderDetails } from "../data-model/medicalPaOrdersModel";
import { isBlockedMedicalOrderStatus } from "../utils/isInvalidMedicalOrderStatus";

/**
 * Whether the current order should show the blocked-order screen instead of detail.
 *
 * @param order - Loaded order document, or null/undefined while fetching
 * @param isLoading - True while the order request is in flight
 * @returns True when status is missing, empty, or agent-in-progress
 */
export const useOrderBlocked = (
  order: GeneralOrderDetails | null | undefined,
  isLoading: boolean = false,
) => {
  return useMemo(() => {
    if (isLoading || !order) {
      return false;
    }
    return isBlockedMedicalOrderStatus(order?.status?.medical_order_status);
  }, [order, isLoading]);
};
